import React from 'react';
import PricingSection from './PricingSection';

const PricingSectionDemo = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Pricing Section Demo
          </h1>
          <p className="text-xl text-gray-600">
            Clean, responsive pricing tables with "Best Value" highlighting
          </p>
        </div>
        
        <PricingSection />
        
        <div className="mt-16 text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Features
          </h2>
          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="font-bold text-lg mb-2">Responsive Design</h3>
              <p className="text-gray-600">
                Adapts beautifully to all screen sizes with mobile-first approach
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="font-bold text-lg mb-2">Best Value Highlighting</h3>
              <p className="text-gray-600">
                Professional plan is highlighted as the best value option
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="font-bold text-lg mb-2">Interactive Elements</h3>
              <p className="text-gray-600">
                Hover effects, smooth transitions, and clear call-to-action buttons
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingSectionDemo;
